"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = applyDefaults;

var _assign = _interopRequireDefault(require("lodash/assign"));

var _omitBy = _interopRequireDefault(require("lodash/omitBy"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function applyDefaults(defaults, attrs) {
  return (0, _assign["default"])({}, defaults, (0, _omitBy["default"])(attrs || {}, _isNil["default"]));
}